// theme-sources/js/core-ui/components/search-form.js
import { sectionLogger } from "./_logger";

const DEBUG = true;
const logger = sectionLogger("SearchForm", DEBUG);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("[data-predictive-input]");
    this.onInput = this.onInput.bind(this);
  }

  connectedCallback() {
    if (!this.input) return;

    this.input.addEventListener("input", this.debounce(this.onInput, 250));
    this.form = this.querySelector("form");

    this.form.addEventListener("submit", (e) => {
      e.preventDefault(); // 🔥 bloque définitivement la navigation vers /search
    });

    logger.info("Init", this.input);
  }

  debounce(fn, delay = 250) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  onInput() {
    const query = this.input.value.trim();

    this.dispatchEvent(
      new CustomEvent("predictive-search:query", {
        bubbles: true,
        detail: { query },
      }),
    );
  }
}

if (!customElements.get("search-form")) {
  customElements.define("search-form", SearchForm);
}
